import { render, staticRenderFns } from "./Rails.vue?vue&type=template&id=94b27744&scoped=true&"
import script from "./Rails.vue?vue&type=script&lang=js&"
export * from "./Rails.vue?vue&type=script&lang=js&"
import style0 from "./Rails.vue?vue&type=style&index=0&id=94b27744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b27744",
  null
  
)

export default component.exports